import QueryStringPopulator from '../populator/query-string.js';
import HashPopulator from '../populator/hash.js';
import CookiePopulator from '../populator/cookie.js';
import JavascriptPopulator from '../populator/javascript.js';
import MyAccount2Populator from '../populator/my-account-2.js';
import SessionStoragePopulator from '../populator/session-storage.js';
import LocalStoragePopulator from '../populator/local-storage.js';

export default class PopulatorFactory {
    static get Populators() {
        return [
            QueryStringPopulator,
            HashPopulator,
            CookiePopulator,
            JavascriptPopulator,
            MyAccount2Populator,
            SessionStoragePopulator,
            LocalStoragePopulator,
        ];
    }

    static build(input) {
        return this.Populators
            .filter((P) => P.applies(input))
            .map((P) => new P(input));
    }
}
